export const formatDate = dateString => {
  const separator = dateString.indexOf('T');
  const date = dateString.substring(0, separator);
  const time = dateString.substring(separator + 1, separator + 9);
  const timeZone = dateString.substring(dateString.length - 6);
  return `${date} ${time} (${timeZone})`;
};
